import { ca } from '@cian/analytics';

import { TJsonQuery } from 'packages/JsonQuery';

export function trackBannerClick(jsonQuery: TJsonQuery, source?: string) {
  ca('eventSite', {
    action: 'click_sopr',
    category: 'trap',
    label: 'NewbuildingFinder_banner',
    name: 'oldevent',
    searchConditions: jsonQuery,
    page: {
      extra: {
        trap_type: 'new_building',
        bannerName: 'Подберём и поможем купить квартиру в новостройке',
        source,
      },
    },
  });
}

export function trackBannerShow(jsonQuery: TJsonQuery, source?: string) {
  ca('eventSite', {
    action: 'show_sopr',
    category: 'trap',
    label: 'NewbuildingFinder_banner',
    name: 'oldevent',
    searchConditions: jsonQuery,
    page: {
      extra: {
        trap_type: 'new_building',
        bannerName: 'Подберём и поможем купить квартиру в новостройке',
        source,
      },
    },
  });
}
